import { ImageCdn } from '@openclassrooms/images-cdn';
import Box from '@classify/react-core-components/Box';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import { getButtonLinkProps, ROUTES } from '@openclassrooms/routing';
import { useI18n } from '@openclassrooms/translations/I18nProvider';

import { styled } from '@classify/react-core-components/styles';

import FooterSocialButtons from './FooterSocialButtons';

import appstoreEnImgSrc from './images/en/appstore.png';
import appstoreFrImgSrc from './images/fr/appstore.png';
import bcorpEnImgSrc from './images/en/b_corp.png';
import bcorpFrImgSrc from './images/fr/b_corp.png';

const StyledImageCdn = styled(ImageCdn)({
  maxWidth: '100%',
  height: 'auto',
}) as ImageCdn;

export default function FooterFollow() {
  const { getLocalisationConfig } = useLocalisationConfig();
  const { i18n, translate } = useI18n();
  const images =
    i18n.lang === 'fr' ? [appstoreFrImgSrc, bcorpFrImgSrc] : [appstoreEnImgSrc, bcorpEnImgSrc];

  const [appstoreImgSrc, bcorpImgSrc] = images;

  return (
    <Box sx={{ display: 'flex', gap: { xs: 3, md: 4 }, flexDirection: 'column' }}>
      <FooterSocialButtons />
      <a
        href={String(getLocalisationConfig('appstore.ios'))}
        aria-label={translate('global.download.ios_app')}
      >
        <StyledImageCdn src={appstoreImgSrc} alt="" width="183" height="58" />
      </a>
      <Box
        {...getButtonLinkProps(ROUTES.ABOUT_US.INDEX, { hash: 'bcorp' })}
        aria-label={translate('global.bcorp-logo.label')}
      >
        <StyledImageCdn src={bcorpImgSrc} alt="" width="216" height="100" />
      </Box>
    </Box>
  );
}
